import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import VisibilityRoundedIcon from '@material-ui/icons/VisibilityRounded';
import VisibilityOffRoundedIcon from '@material-ui/icons/VisibilityOffRounded';
import { apiList, verifyLogin } from '../../helpers';
import SectionCard from './SectionCard';

export default function ChangePassword() {
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [reNewPassword, setReNewPassword] = useState('');
  const [showPasswords, setShowPasswords] = useState(false);
  const [loading, setLoading] = useState(false);

  const mismatch = reNewPassword.length > 0 && newPassword !== reNewPassword;

  const changePassword = (event) => {
    event.preventDefault();
    if (oldPassword.length < 1 || newPassword.length < 1 || reNewPassword.length < 1) {
      toast.error('Password can not be empty.');
      return;
    }
    if (newPassword !== reNewPassword) {
      toast.error('New Password does not match with Re-entered new password.');
      return;
    }
    const { session, user } = verifyLogin();
    const config = { headers: { session } };
    setLoading(true);
    axios.post(`${apiList.CHANGE_PASSWORD}`, {
      id: user.id,
      password: oldPassword,
      newPassword,
    }, config)
      .then((response) => {
        setLoading(false);
        if (response) {
          toast.success('Password Changed successfully.');
          setOldPassword('');
          setNewPassword('');
          setReNewPassword('');
        }
      })
      .catch((error) => {
        toast.error(`${error.response.data.error || error.response.data.message}`);
        setLoading(false);
      });
  };

  const visibilityToggle = (
    <InputAdornment position='end'>
      <IconButton
        size='small'
        aria-label={showPasswords ? 'Hide passwords' : 'Show passwords'}
        onClick={() => setShowPasswords(!showPasswords)}
        edge='end'
      >
        {showPasswords ? <VisibilityOffRoundedIcon fontSize='small' /> : <VisibilityRoundedIcon fontSize='small' />}
      </IconButton>
    </InputAdornment>
  );

  const passwordField = (id, label, value, setValue, extra = {}) => (
    <TextField
      id={id}
      label={label}
      variant='outlined'
      fullWidth
      disabled={loading}
      type={showPasswords ? 'text' : 'password'}
      value={value}
      onChange={(e) => setValue(e.target.value)}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...extra}
    />
  );

  return (
    <form onSubmit={changePassword} noValidate>
      <SectionCard
        Icon={LockOutlinedIcon}
        title='Password'
        subtitle='Use a password you do not use anywhere else.'
        footer={(
          <Button
            type='submit'
            variant='contained'
            color='primary'
            disabled={loading}
            startIcon={loading ? <CircularProgress size={16} color='inherit' /> : null}
          >
            {loading ? 'Updating…' : 'Update password'}
          </Button>
        )}
      >
        <div className='form-stack'>
          {passwordField('oldPassword', 'Current password', oldPassword, setOldPassword, {
            autoComplete: 'current-password',
            InputProps: { endAdornment: visibilityToggle },
          })}
          {passwordField('newPassword', 'New password', newPassword, setNewPassword, {
            autoComplete: 'new-password',
          })}
          {passwordField('reNewPassword', 'Confirm new password', reNewPassword, setReNewPassword, {
            autoComplete: 'new-password',
            error: mismatch,
            helperText: mismatch ? 'Passwords do not match.' : ' ',
          })}
        </div>
      </SectionCard>
    </form>
  );
}
